import Modals from '../../../../shared/types/enums/modals';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import { store } from '../../../../shared/store/store';

const getModalStyle = () => {
  const { modal } = store.getState();
  switch (modal.current) {
    case Modals.ANONYMOUS_GENERIC:
    case Modals.ANONYMOUS_ZAPPER:
      return {
        top: `${284 * Screen.widthRatio}px`,
      };
  }
  return '';
};

const ModalDescription = styled.div<React.CSSProperties>`
  display: flex;
  flex-direction: column;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  ${() => {
    return getModalStyle();
  }}
`;

export default ModalDescription;
